export default function createMixins(breakpoints, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
spacing = undefined, mixins = {}) {
    return {
        toolbar: {
            minHeight: 56,
            [`${breakpoints.up("xs")} and (orientation: landscape)`]: {
                minHeight: 48,
            },
            [breakpoints.up("sm")]: {
                minHeight: 64,
            },
        },
        ...mixins,
    };
}
